module.exports = __webpack_public_path__ + "fonts/63f25c9c0b11f5baecce35ac55b900f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/tick_list_white.svg
// module id = 2086
// module chunks = 0